(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-footer-r2"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-header-r2"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diva-conversion-home"] && !Shopify.designMode) return;
  try {
    
function initializeDivaHome(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';

  const menuToggle = root.querySelector('[data-diva-menu]');
  const header = root.querySelector('.dc-header');
  menuToggle?.addEventListener('click', () => { const open = menuToggle.getAttribute('aria-expanded') !== 'true'; menuToggle.setAttribute('aria-expanded', String(open)); header.dataset.menuOpen = String(open); });
  root.addEventListener('keydown', event => { if (event.key === 'Escape') { root.querySelectorAll('.dc-nav-group[open]').forEach(item => item.open = false); if (menuToggle?.getAttribute('aria-expanded') === 'true') { menuToggle.setAttribute('aria-expanded', 'false'); header.dataset.menuOpen = 'false'; menuToggle.focus(); } } });
  const announcementBar = root.querySelector('[data-diva-announcements]');
  const slides = [...root.querySelectorAll('[data-announcement]')];
  const motionButton = root.querySelector('[data-diva-motion]');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduced.matches;
  let slideIndex = 0;
  const reflectMotion = () => { root.dataset.motionPaused = String(paused); if (motionButton) { motionButton.setAttribute('aria-label', paused ? motionButton.dataset.playLabel : motionButton.dataset.pauseLabel); motionButton.querySelector('[data-motion-symbol]').textContent = paused ? '▷' : 'Ⅱ'; } };
  reflectMotion();
  motionButton?.addEventListener('click', () => { paused = !paused; reflectMotion(); });
  const timer = slides.length > 1 ? window.setInterval(() => { if (paused || document.hidden || announcementBar.matches(':hover') || announcementBar.contains(document.activeElement)) return; slides[slideIndex].hidden = true; slideIndex = (slideIndex + 1) % slides.length; slides[slideIndex].hidden = false; }, Math.max(3, Number(announcementBar.dataset.interval) || 5) * 1000) : null;
  root.addEventListener('shopify:block:select', event => { const slide = event.target.closest('[data-announcement]'); if (slide) { paused = true; reflectMotion(); slides.forEach(item => item.hidden = item !== slide); slideIndex = slides.indexOf(slide); } });
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root) && timer) window.clearInterval(timer); });

  const selector = root.querySelector('[data-diva-variant]');
  if (selector) selector.addEventListener('change', () => {
    const option = selector.selectedOptions[0];
    root.querySelector('[data-diva-price]').textContent = option.dataset.price;
    root.querySelector('[data-diva-sticky-price]').textContent = option.dataset.price;
    const compare = root.querySelector('[data-diva-compare]');
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
    const image = root.querySelector('[data-diva-variant-image]');
    if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
  });
  const sticky = root.querySelector('[data-diva-sticky]');
  const hero = root.querySelector('.dc-hero');
  const buy = root.querySelector('[data-diva-buy]');
  if (sticky && hero && buy && 'IntersectionObserver' in window) {
    let heroVisible = true;
    let buyVisible = false;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.target === hero) heroVisible = entry.isIntersecting; if (entry.target === buy) buyVisible = entry.isIntersecting; });
      sticky.hidden = heroVisible || buyVisible;
    });
    observer.observe(hero); observer.observe(buy);
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) observer.disconnect(); }, { once: true });
  }
}
document.querySelectorAll('[data-diva-home]').forEach(initializeDivaHome);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-diva-home]').forEach(initializeDivaHome));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diva-product-header"]) return;
  try {
    

function initializeDivaProductHeader(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';

  const menuToggle = root.querySelector('[data-diva-menu]');
  const header = root.querySelector('.dc-header');
  menuToggle?.addEventListener('click', () => { const open = menuToggle.getAttribute('aria-expanded') !== 'true'; menuToggle.setAttribute('aria-expanded', String(open)); header.dataset.menuOpen = String(open); });
  root.addEventListener('keydown', event => { if (event.key === 'Escape') { root.querySelectorAll('.dc-nav-group[open]').forEach(item => item.open = false); if (menuToggle?.getAttribute('aria-expanded') === 'true') { menuToggle.setAttribute('aria-expanded', 'false'); header.dataset.menuOpen = 'false'; menuToggle.focus(); } } });
  const announcementBar = root.querySelector('[data-diva-announcements]');
  const slides = [...root.querySelectorAll('[data-announcement]')];
  const motionButton = root.querySelector('[data-diva-motion]');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused = reduced.matches;
  let slideIndex = 0;
  const reflectMotion = () => { root.dataset.motionPaused = String(paused); if (motionButton) { motionButton.setAttribute('aria-label', paused ? motionButton.dataset.playLabel : motionButton.dataset.pauseLabel); motionButton.querySelector('[data-motion-symbol]').textContent = paused ? '▷' : 'Ⅱ'; } };
  reflectMotion();
  motionButton?.addEventListener('click', () => { paused = !paused; reflectMotion(); });
  const timer = slides.length > 1 ? window.setInterval(() => { if (paused || document.hidden || announcementBar.matches(':hover') || announcementBar.contains(document.activeElement)) return; slides[slideIndex].hidden = true; slideIndex = (slideIndex + 1) % slides.length; slides[slideIndex].hidden = false; }, Math.max(3, Number(announcementBar.dataset.interval) || 5) * 1000) : null;
  root.addEventListener('shopify:block:select', event => { const slide = event.target.closest('[data-announcement]'); if (slide) { paused = true; reflectMotion(); slides.forEach(item => item.hidden = item !== slide); slideIndex = slides.indexOf(slide); } });
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root) && timer) window.clearInterval(timer); });

}
document.querySelectorAll('[data-diva-product-header]').forEach(initializeDivaProductHeader);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-diva-product-header]').forEach(initializeDivaProductHeader));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diva-product-story"] && !Shopify.designMode) return;
  try {
    
const divaStoryMobile = matchMedia('(max-width: 749px)');
function syncDivaStoryVideoControls() {
  document.querySelectorAll('[data-dp-mobile-clean-video] video').forEach(video => {
    video.controls = !divaStoryMobile.matches;
  });
}
syncDivaStoryVideoControls();
divaStoryMobile.addEventListener('change', syncDivaStoryVideoControls);
document.addEventListener('shopify:section:load', syncDivaStoryVideoControls);
function initDivaStory(root){const track=root.querySelector('[data-dp-track]');if(!track||root.dataset.ready)return;root.dataset.ready='true';const prev=root.querySelector('[data-dp-prev]'),next=root.querySelector('[data-dp-next]');const update=()=>{prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};const move=d=>track.scrollBy({left:d*(track.querySelector('article').getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});const resize=new ResizeObserver(update);resize.observe(track);update();document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root))resize.disconnect()});}
document.querySelectorAll('[data-dp-story]').forEach(initDivaStory);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-dp-story]').forEach(initDivaStory));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diva-reviews-demo"] && !Shopify.designMode) return;
  try {
    
function initializeDivaReviews(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const track=root.querySelector('[data-dr-track]'),prev=root.querySelector('[data-dr-prev]'),next=root.querySelector('[data-dr-next]');
 const update=()=>{prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
 const move=direction=>track.scrollBy({left:direction*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
 prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});
 track.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
 const observer=new ResizeObserver(update);observer.observe(track);update();
 root.addEventListener('shopify:block:select',event=>{const card=event.target.closest('.dr-review');if(card)track.scrollTo({left:card.offsetLeft-track.offsetLeft,behavior:'auto'});});
 document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))observer.disconnect();});
}
document.querySelectorAll('[data-diva-reviews]').forEach(initializeDivaReviews);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-diva-reviews]').forEach(initializeDivaReviews));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
